import React from 'react';
class AdvLoadingSymbol extends React.Component {
  render() {
    return (
      <div
        className="col-12 grid-margin stretch-card"
        style={{ marginTop: '50px' }}
      >
        <div className="square-box-loader">
          <div className="square-box-loader-container">
            <div className="square-box-loader-corner-top"></div>
            <div className="square-box-loader-corner-bottom"></div>
          </div>
          <div className="square-box-loader-square"></div>
        </div>
      </div>
    );
  }
}
export default AdvLoadingSymbol;
